<script setup lang="ts">
import CloseIcon from '@/assets/svg/close-24.svg?component';

defineProps<{
  label: string;
}>();

const emit = defineEmits<{
  (e: 'close'): void;
}>();
</script>

<template>
  <!-- h-8 is the tap target; -m-1.5 keeps it in the same 20px slot as the glyph. -->
  <button
    type="button"
    :aria-label="label"
    data-test-id="enrichment-trace-panel-close"
    class="-m-1.5 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded text-tint-400 transition-colors hover:text-highlight-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-highlight-300"
    @click="emit('close')"
  >
    <CloseIcon class="h-3 w-3" viewBox="0 0 24 24" aria-hidden="true" />
  </button>
</template>
